import React, { useState } from 'react';

import chatbotIcon from 'images/chatbot-justsleep.png';

import { getChatbotConfig } from './config';
import styles from './index.css';

const ChatbotWidget = ({ hotel, lan, bottomOffset = 0 }) => {
	const [showBubble, setShowBubble] = useState(true);
	const config = getChatbotConfig(hotel, lan);

	if (!config) return null;

	const { url, text } = config;
	const widgetStyle = { bottom: `${16 + bottomOffset}px` };

	const openChatbot = () => {
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	return (
		<div className={styles.widget} style={widgetStyle}>
			<button
				className={styles.iconBtn}
				type="button"
				aria-label="Open Chatbot"
				onClick={openChatbot}
			>
				<img className={styles.icon} src={chatbotIcon} alt="" />
			</button>
			{showBubble && (
				<div className={styles.bubble} onClick={openChatbot} role="button" tabIndex="0" onKeyPress={() => {}}>
					{text}
					<div
						role="button"
						tabIndex="0"
						className={styles.closeBtn}
						aria-label="Close"
						onClick={e => {
							e.stopPropagation();
							setShowBubble(false);
						}}
						onKeyPress={() => {}}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 12 13">
							<path fill="none" fillRule="evenodd" stroke="#FFF" strokeLinecap="square" d="M.305 11.695L11.695.305.305 11.695zm0-11.39l11.39 11.39" />
						</svg>
					</div>
				</div>
			)}
		</div>
	);
};

export default ChatbotWidget;



// WEBPACK FOOTER //
// ./src/components/molecules/ChatbotWidget/component.js